module.exports = __webpack_public_path__ + "img/value-4.e5112266.png";